(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ww-cart-compact-design"] && !Shopify.designMode) return;
  try {
    (() => {
  const feeSelector = '.mw-fee:is([data-fee-id="14829609222475"], [data-fee-id="15989424947531"])';
  let scheduled = false;
  const openKeys = new Set();
  function refresh() {
    scheduled = false;
    const main = document.querySelector('[data-section-type="cart-template"]:not([data-section-modification="drawer"])');
    const scope = main || document;
    const state = scope.querySelector('[data-ww-express-state]');
    const selected = document.querySelector(feeSelector + ' input:checked');
    const express = state?.dataset.feePresent === 'true' || Boolean(selected && !selected.disabled);
    document.querySelectorAll('[data-ww-standard-delivery]').forEach(node => { if (node.hidden !== express) node.hidden = express; });
    document.querySelectorAll('[data-ww-express-delivery]').forEach(node => { if (node.hidden === express) node.hidden = !express; });
    document.querySelectorAll('[data-ww-config-key]').forEach(node => {
      if (openKeys.has(node.dataset.wwConfigKey) && !node.open) node.open = true;
    });
  }
  function schedule() { if (!scheduled) { scheduled = true; requestAnimationFrame(refresh); } }
  document.addEventListener('toggle', event => {
    const node = event.target;
    if (!node.matches?.('[data-ww-config-key]')) return;
    if (node.open) openKeys.add(node.dataset.wwConfigKey); else openKeys.delete(node.dataset.wwConfigKey);
  }, true);
  document.addEventListener('change', event => { if (event.target.closest(feeSelector)) schedule(); });
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  window.addEventListener('pageshow', schedule);
  const printDetails = [];
  window.addEventListener('beforeprint', () => {
    document.querySelectorAll('.ww-cart-configuration:not([open])').forEach(node => { printDetails.push(node); node.open = true; });
  });
  window.addEventListener('afterprint', () => { printDetails.splice(0).forEach(node => { node.open = false; }); });
  refresh();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ww-cart-design"] && !Shopify.designMode) return;
  try {
    (() => {
    if (!document.body.classList.contains('template-cart')) return;
    const root = document.getElementById('MainContent');
    if (!root) return;
    let queued = false;
    function styleEU() {
      queued = false;
      root.querySelectorAll('.mw-fee.mw-fee--type-cart').forEach(fee => {
        const subtotal = fee.closest('.js-cart-subtotal');
        const totals = subtotal && subtotal.querySelector('.ww-cart-totals');
        if (totals && fee.parentElement !== subtotal) subtotal.insertBefore(fee, totals);
      });
      root.querySelectorAll('tax-exempt-form').forEach(host => {
        const shadow = host.shadowRoot;
        if (!shadow || shadow.querySelector('[data-ww-cart-style]')) return;
        const style = document.createElement('style');
        style.setAttribute('data-ww-cart-style', '');
        style.textContent = '.tea-checkbox-form{padding:18px;border:1px solid #dce0d7;border-radius:9px;background:#f4f5f1;margin:0}.teac-title-text{font-size:15px;line-height:1.45;color:#161e13}.teac-body-text{font-size:13px;line-height:1.6;color:#596153;margin-top:7px}.tea-checkbox label:before{margin-top:1px;border-color:#7f8976}.tea-checkbox svg{margin-top:1px}.tea-checkbox:has(input:focus-visible){outline:3px solid #161e13;outline-offset:4px;border-radius:4px}';
        shadow.appendChild(style);
      });
    }
    function schedule() { if (!queued) { queued = true; requestAnimationFrame(styleEU); } }
    customElements.whenDefined('tax-exempt-form').then(schedule);
    new MutationObserver(schedule).observe(root, { childList:true, subtree:true });
    schedule();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ww-express-eligibility"] && !Shopify.designMode) return;
  try {
    (() => {
  'use strict';
  if (window.__wwExpressEligibility) return;
  window.__wwExpressEligibility = true;
  const feeIds = ['53543738376523', '53543738409291', '53543740440907'];
  const selector = '.mw-fee:is([data-fee-id="14829609222475"], [data-fee-id="15989424947531"])';
  let queued = false;
  let removing = false;
  let failed = false;
  const isFee = item => String(item.product_id) === '15989424947531' || feeIds.includes(String(item.variant_id));
  async function removeUnusedFee(state) {
    if (removing || failed) return;
    removing = true;
    document.documentElement.classList.add('ww-express-updating');
    try {
      const root = window.Shopify?.routes?.root || '/';
      const sectionId = state.dataset.sectionId;
      if (!sectionId) throw new Error('section');
      const response = await fetch(root + 'cart?section_id=' + encodeURIComponent(sectionId), { cache: 'no-store' });
      if (!response.ok) throw new Error('cart');
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const current = html.querySelector('[data-ww-express-state]');
      if (!current) throw new Error('state');
      if (current.dataset.allowed === 'true') return;
      const keys = (current.dataset.feeKeys || '').split(',').filter(Boolean);
      if (!keys.length) return;
      const update = await fetch(root + 'cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: Object.fromEntries(keys.map(key => [key, 0])) })
      });
      if (!update.ok) throw new Error('update');
      const updated = await update.json();
      if (updated.items.some(isFee)) throw new Error('fee');
      window.location.reload();
    } catch (error) {
      failed = true;
      document.documentElement.classList.remove('ww-express-unavailable');
      const box = document.querySelector(selector);
      if (box && !box.querySelector('[data-ww-express-error]')) {
        const note = document.createElement('p');
        note.dataset.wwExpressError = '';
        note.setAttribute('role', 'alert');
        note.textContent = 'Der Expressdruck-Aufschlag konnte nicht entfernt werden. Bitte laden Sie den Warenkorb neu und entfernen Sie den Aufschlag vor dem Fortfahren.';
        box.prepend(note);
      }
    } finally {
      removing = false;
      document.documentElement.classList.remove('ww-express-updating');
    }
  }
  function refresh() {
    queued = false;
    const scope = document.querySelector('[data-section-type="cart-template"]:not([data-section-modification="drawer"])') || document;
    const state = scope.querySelector('[data-ww-express-state]');
    if (!state) return;
    const unavailable = state.dataset.allowed === 'false';
    document.documentElement.classList.toggle('ww-express-unavailable', unavailable && !failed);
    document.querySelectorAll(selector + ' input').forEach(input => {
      if (unavailable) {
        if (!input.disabled) input.dataset.wwExpressDisabled = 'true';
        input.disabled = true;
        input.checked = false;
      } else if (input.dataset.wwExpressDisabled) {
        input.disabled = false;
        delete input.dataset.wwExpressDisabled;
      }
    });
    if (unavailable && state.dataset.feePresent === 'true') removeUnusedFee(state);
  }
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(refresh);
  }
  document.addEventListener('click', event => {
    if ((removing || failed) && event.target.closest('.js-cart-button, [name="checkout"]')) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
  document.addEventListener('submit', event => {
    if ((removing || failed) && event.submitter?.matches('.js-cart-button, [name="checkout"]')) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', schedule);
  window.addEventListener('pageshow', schedule);
  refresh();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ww-info-layout"] && !Shopify.designMode) return;
  try {
    (() => {
  function enhance() {
    const root = document.querySelector('.ww-info');
    if (!root) return;
    const handle = root.dataset.infoPage;
    const body = handle === 'preisanfragen-angebot' ? root.querySelector('.text-section__content') : root.querySelector('.page-default > .rte');
    if (body && !body.dataset.infoReady && ['druckarten','versandkosten-lieferzeiten-expressversand','express-druck-und-express-versand','showroom-in-berlin','material-druckgrossen-passform','preisanfragen-angebot'].includes(handle)) {
      body.dataset.infoReady = 'true';
      if (handle === 'preisanfragen-angebot') {
        const intro = body.querySelector(':scope > h3');
        if (intro) { const p = document.createElement('p'); p.textContent = intro.textContent; intro.replaceWith(p); }
        body.querySelectorAll(':scope > p').forEach(p => {
          const label = p.firstElementChild;
          if (label?.tagName !== 'STRONG' || !/^Methode [12]/.test(label.textContent.trim())) return;
          const h = document.createElement('h2'); h.textContent = label.textContent.trim(); label.remove(); p.before(h);
        });
      }
      if (handle === 'druckarten') {
        body.querySelectorAll(':scope > p').forEach(p => {
          const first = p.firstElementChild;
          if (first?.tagName !== 'STRONG' || first.nextElementSibling?.tagName !== 'BR') return;
          const heading = document.createElement('h2');
          heading.textContent = first.textContent;
          first.nextElementSibling.remove(); first.remove(); p.before(heading);
        });
      }
      let card = document.createElement('div');
      card.className = 'ww-info-intro';
      const nodes = Array.from(body.childNodes);
      body.append(card);
      const headings = [];
      nodes.forEach(node => {
        if (node.nodeType === 1 && /^H[234]$/.test(node.tagName)) {
          if (!node.textContent.trim()) { node.remove(); return; }
          card = document.createElement('section'); card.className = 'ww-info-card'; body.append(card);
          const h = document.createElement('h2'); h.textContent = node.textContent.trim();
          h.id = node.id || 'info-topic-' + (headings.length + 1);
          card.setAttribute('aria-labelledby',h.id); card.append(h); headings.push(h); node.remove();
        } else { card.append(node); }
      });
      body.classList.add('ww-info-grouped');
      if (headings.length >= 3 && handle !== 'druckarten') {
        const nav = document.createElement('nav'); nav.className='ww-info-toc'; nav.setAttribute('aria-label',root.dataset.tocLabel);
        const title = document.createElement('strong'); title.textContent=root.dataset.tocLabel;
        const links = document.createElement('div');
        headings.forEach(h => { const a=document.createElement('a'); a.href='#'+h.id; a.textContent=h.textContent; links.append(a); });
        nav.append(title,links); body.before(nav);
      }
    }
    root.querySelectorAll('.rte table').forEach((table,index) => {
      if (table.closest('.ww-info-table-scroll')) return;
      if (handle === 'versandkosten-lieferzeiten-expressversand' && !table.tHead && table.rows.length) {
        const first=table.rows[0]; const head=table.createTHead(); const row=document.createElement('tr');
        Array.from(first.cells).forEach(td => { const th=document.createElement('th'); th.scope='col'; th.textContent=td.textContent; row.append(th); });
        head.append(row); first.remove();
      }
      const wrap=document.createElement('div'); wrap.className='ww-info-table-scroll'; wrap.tabIndex=0; wrap.setAttribute('role','region');
      const heading=table.closest('.ww-info-card')?.querySelector('h2')?.textContent;
      wrap.setAttribute('aria-label',heading || root.dataset.tableLabel+' '+(index+1));
      table.before(wrap); wrap.append(table);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',enhance,{once:true}); else enhance();
  document.addEventListener('shopify:section:load',enhance);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ww-order-finish"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = () => {
    document.querySelectorAll('[data-ww-order-finish]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const form = root.closest('form');
      const dialog = root.querySelector('dialog');
      const open = root.querySelector('[data-ww-order-open]');
      open.addEventListener('click', () => dialog.showModal());
      root.querySelectorAll('[data-ww-order-close]').forEach(button => button.addEventListener('click', () => dialog.close()));
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      });
      const status = root.querySelector('[data-ww-order-cart-status]');
      const syncCart = () => {
        const counts = [...document.querySelectorAll('.js-header-cart-item-count-wrapper[data-cart-count]')];
        if (!counts.length) return;
        const filled = counts.some(el => Number(el.dataset.cartCount) > 0);
        const text = filled ? root.dataset.cartFilled : root.dataset.cartEmpty;
        if (status.textContent !== text) status.textContent = text;
      };
      const header = document.querySelector('header');
      if (header) new MutationObserver(syncCart).observe(header, {childList:true,subtree:true,attributes:true,attributeFilter:['data-cart-count']});
      syncCart();
      const syncPrint = () => {
        const selected = [...(form?.querySelectorAll('.gpo-element input:checked') || [])].some(input => input.value.trim().toLowerCase() === 'mit druck');
        root.querySelector('[data-ww-order-print-hint]').hidden = !selected;
      };
      form?.addEventListener('change', syncPrint);
      form?.addEventListener('input', syncPrint);
      syncPrint();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ww-price-summary"] && !Shopify.designMode) return;
  try {
    (() => {
  const parseAmount = text => {
    const raw = String(text).replace(/[^\d.,-]/g, '');
    if (!raw || !/\d/.test(raw)) return NaN;
    const last = Math.max(raw.lastIndexOf(','), raw.lastIndexOf('.'));
    const decimals = last >= 0 && raw.length - last - 1 <= 2;
    const value = decimals ? raw.slice(0, last).replace(/[.,]/g, '') + '.' + raw.slice(last + 1) : raw.replace(/[.,]/g, '');
    return Math.round(Number(value) * 100);
  };
  const parseRange = text => {
    const s = text.replace(/(\d)[.,\s\u00a0\u202f](?=\d{3}(?:\D|$))/g, '$1').trim();
    const closed = s.match(/^(\d+)\s*[-–—]\s*(\d+)(?:\D.*)?$/);
    if (closed) return [Number(closed[1]), Number(closed[2])];
    const open = s.match(/^(\d+)\s*\+/) || s.match(/^(?:ab|from|at least)\s+(\d+)/i);
    return open ? [Number(open[1]), Infinity] : null;
  };
  const calculate = (lines, percent) => {
    if (!Number.isFinite(percent) || percent < 0 || percent > 100 || lines.some(l => !Number.isSafeInteger(l.unit) || l.unit < 0 || !Number.isSafeInteger(l.quantity) || l.quantity < 1)) return null;
    let base = 0, addons = 0, fixed = 0, discount = 0;
    for (const line of lines) {
      const gross = line.unit * line.quantity;
      if (!Number.isSafeInteger(gross)) return null;
      if (line.kind === 'base') base += gross;
      else if (line.kind === 'fixed') fixed += gross;
      else addons += gross;
      if (line.discounted) discount += Math.floor(line.unit * percent / 100 + 1e-9) * line.quantity;
    }
    const total = base + addons + fixed - discount;
    if (!Number.isSafeInteger(total)) return null;
    return { base, addons, fixed, discount, total, vat: Math.round(total * 19 / 119) };
  };
  const template = document.getElementById('ww-price-template');
  const contextNode = document.getElementById('ww-price-context');
  const root = document.getElementById('MainContent');
  if (!template || !contextNode || !root) return;
  const context = JSON.parse(contextNode.textContent);
  const labels = context.labels;
  const money = value => new Intl.NumberFormat(context.locale, { style: 'currency', currency: context.currency }).format(value / 100);
  const format = (text, values) => text.replace(/\[\[(\w+)\]\]/g, (_, key) => values[key] ?? '');
  const addonGroups = { 'option-set-1186128-radio-1': 'Standardrabatt', 'option-set-1222223-buttons-2': 'Textilrabatt', 'option-set-1223820-buttons-1': 'Portwest-Rabatt', 'option-set-1223820-buttons-2': 'Portwest-Rabatt', 'option-set-1219507-dropdown-2': 'Standardrabatt', 'option-set-1186128-buttons-2': 'Standardrabatt', 'option-set-1222173-buttons-5': 'none' };
  const states = new Map();
  const desktop = window.matchMedia('(min-width: 992px)');
  let frame = 0, trailing = 0;
  const setText = (host, selector, text) => {
    const element = host.querySelector(selector);
    if (element && element.textContent !== text) element.textContent = text;
  };
  const visible = element => element && element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden';
  function readTier(form, quantity, product) {
    const table = form.querySelector('.lb-vd-table');
    const expected = ['Standardrabatt', 'Portwest-Rabatt', 'Textilrabatt'].some(tag => product.tags?.includes(tag));
    if (!table) return { percent: expected ? null : 0, table: false };
    const rows = Array.from(table.querySelectorAll('tbody tr')).map(row => {
      const cells = row.querySelectorAll('td');
      const range = cells[0] && parseRange(cells[0].textContent);
      const match = cells[1]?.textContent.match(/(\d+(?:[.,]\d+)?)\s*%/);
      return range && match ? { min: range[0], max: range[1], percent: Number(match[1].replace(',', '.')) } : null;
    }).filter(Boolean);
    if (!rows.length) return { percent: null, table: true };
    const active = rows.find(row => quantity >= row.min && quantity <= row.max);
    return { percent: active ? active.percent : quantity < Math.min(...rows.map(row => row.min)) ? 0 : null, table: true };
  }
  function selectedAddons(form, product, quantity) {
    const lines = [];
    let appTotal = 0;
    const hidden = form.querySelector('.gpo-hidden-inputs');
    const app = form.querySelector('.gpo-app');
    if (app && !hidden) return null;
    for (const input of hidden?.querySelectorAll('input:not(:disabled)') || []) {
      const ids = input.getAttribute('gpo-data-variant-id');
      const rawPrice = input.getAttribute('data-addon-price');
      if (!ids && !rawPrice) continue;
      if (rawPrice) return null;
      const handles = (input.getAttribute('gpo-data-product-handle') || '').split(',');
      const mode = input.getAttribute('data-advanced-addon') || 'default';
      if (!['default', 'quantity_fixed_by_merchant'].includes(mode)) return null;
      const multiplier = Number(input.getAttribute('data-quantity') || 1);
      if (!Number.isSafeInteger(multiplier) || multiplier < 1) return null;
      const fixed = mode === 'quantity_fixed_by_merchant';
      for (const [index, id] of ids.split(',').entries()) {
        if (!/^\d+$/.test(id.trim())) return null;
        const handle = handles[index] || handles[0];
        const group = addonGroups[handle];
        if (!group || (group !== 'none' && !product.tags?.includes(group)) || (fixed && group !== 'none')) return null;
        const variant = context.addons.find(addon => addon.handle === handle)?.variants.find(v => String(v.id) === id.trim());
        const appVariant = window.GPOConfigs?.addonVariants?.find(v => String(v.id) === id.trim());
        const unit = appVariant?.price ?? variant?.price;
        if (!Number.isSafeInteger(unit) || unit < 0) return null;
        appTotal += unit * multiplier;
        lines.push({ unit, quantity: multiplier * (fixed ? 1 : quantity), kind: fixed ? 'fixed' : 'addon', discounted: group !== 'none', taxable: variant?.taxable === true });
      }
    }
    const totalNode = app?.querySelector('.gpo-total-text .money');
    if (totalNode) {
      const observed = parseAmount(totalNode.textContent);
      if (!Number.isFinite(observed) || Math.abs(observed - appTotal) > 1) return null;
    } else if (appTotal > 0) return null;
    return lines;
  }
  function isComplete(form) {
    if (form.querySelector('.ww-design-card:not([hidden]):not(.ww-design-card--complete)')) return false;
    return Array.from(form.querySelectorAll('.gpo-element')).every(group => {
      if (!group.querySelector('.gpo-label.required, label.required') || !visible(group)) return true;
      const fields = Array.from(group.querySelectorAll('input:not(:disabled), select:not(:disabled), textarea:not(:disabled)')).filter(field => field.type !== 'hidden');
      const choices = fields.filter(field => field.type === 'checkbox' || field.type === 'radio');
      return choices.length ? choices.some(field => field.checked) : fields.some(field => String(field.value || '').trim());
    });
  }
  function refreshUnit(state, variant, tier, valid, quantity) {
    const host = state.form.querySelector('[data-ww-unit-price]');
    if (!host) return;
    const hasPrice = variant && Number.isSafeInteger(variant.price) && variant.price >= 0;
    const showNet = hasPrice && context.country === 'DE' && context.taxesIncluded && variant.taxable === true && !context.taxExempt;
    const net = amount => amount - Math.round(amount * 19 / 119);
    setText(host, '[data-ww-unit-base-gross]', hasPrice ? money(variant.price) : '—');
    setText(host, '[data-ww-unit-base-net]', showNet ? money(net(variant.price)) : '—');
    setText(host, '[data-ww-unit-gross-label]', context.taxesIncluded && variant?.taxable && !context.taxExempt ? labels.unitGross : labels.unitPrice);
    for (const column of host.querySelectorAll('[data-ww-unit-net-column]')) column.hidden = !showNet;
    const hasTier = Number.isFinite(tier.percent) && tier.percent >= 0 && tier.percent <= 100;
    const discountedUnit = hasPrice && hasTier ? variant.price - Math.floor(variant.price * tier.percent / 100 + 1e-9) : null;
    const articleTotal = valid && discountedUnit !== null ? discountedUnit * quantity : null;
    const hasArticleTotal = Number.isSafeInteger(articleTotal) && articleTotal >= 0 && !context.taxExempt && !state.form.querySelector('[name="selling_plan"]')?.value;
    setText(host, '[data-ww-unit-total-count]', valid ? format(labels.count, { quantity }) : '—');
    setText(host, '[data-ww-unit-total-net]', hasArticleTotal && showNet ? money(net(articleTotal)) : '—');
    setText(host, '[data-ww-unit-total-gross]', hasArticleTotal ? money(articleTotal) : '—');
    const active = hasPrice && valid && !context.taxExempt && !state.form.querySelector('[name="selling_plan"]')?.value && Number.isFinite(tier.percent) && tier.percent > 0 && tier.percent <= 100;
    const row = host.querySelector('[data-ww-unit-discount-row]');
    if (row.dataset.active !== String(Boolean(active))) row.dataset.active = String(Boolean(active));
    if (row.getAttribute('aria-hidden') !== String(!active)) row.setAttribute('aria-hidden', String(!active));
    if (active) {
      setText(host, '[data-ww-unit-discount-label]', format(labels.unitDiscount, { percent: tier.percent }));
      setText(host, '[data-ww-unit-discount-net]', showNet ? money(net(discountedUnit)) : '—');
      setText(host, '[data-ww-unit-discount-gross]', money(discountedUnit));
    }
  }
  function refreshTierPrices(state, variant) {
    const table = state.form.querySelector('.lb-vd-table');
    const head = table?.querySelector('thead tr');
    if (!head) return;
    table.classList.add('ww-tier-prices');
    const hasPrice = variant && Number.isSafeInteger(variant.price) && variant.price >= 0 && !context.taxExempt && !state.form.querySelector('[name="selling_plan"]')?.value;
    const showNet = hasPrice && context.country === 'DE' && context.taxesIncluded && variant.taxable === true;
    const grossLabel = context.taxesIncluded && variant?.taxable && !context.taxExempt ? labels.tierGross : labels.tierPrice;
    const ensureCell = (row, type, name, label) => {
      let cell = row.querySelector('[data-ww-tier-' + name + ']');
      if (!cell) {
        cell = document.createElement(type);
        cell.className = 'ww-tier-price-cell ' + (type === 'th' ? 'lb-vd-table-head-text' : 'lb-vd-table-body-text');
        cell.setAttribute('data-ww-tier-' + name, '');
        if (type === 'th') cell.scope = 'col';
        row.appendChild(cell);
      }
      if (type === 'th' && cell.textContent !== label) cell.textContent = label;
      if (type === 'td' && cell.dataset.label !== label) cell.dataset.label = label;
      cell.hidden = name === 'net' && !showNet;
      return cell;
    };
    ensureCell(head, 'th', 'net', labels.tierNet);
    ensureCell(head, 'th', 'gross', grossLabel);
    for (const row of table.querySelectorAll('tbody tr')) {
      const cells = row.querySelectorAll('td');
      const range = cells[0] && parseRange(cells[0].textContent);
      const match = cells[1]?.textContent.match(/(\d+(?:[.,]\d+)?)\s*%/);
      const percent = match ? Number(match[1].replace(',', '.')) : NaN;
      const valid = hasPrice && range && Number.isFinite(percent) && percent >= 0 && percent <= 100;
      const gross = valid ? variant.price - Math.floor(variant.price * percent / 100 + 1e-9) : null;
      const netCell = ensureCell(row, 'td', 'net', labels.tierNet);
      const grossCell = ensureCell(row, 'td', 'gross', grossLabel);
      const netText = valid && showNet ? money(gross - Math.round(gross * 19 / 119)) : '—';
      const grossText = valid ? money(gross) : '—';
      if (netCell.textContent !== netText) netCell.textContent = netText;
      if (grossCell.textContent !== grossText) grossCell.textContent = grossText;
    }
    const container = table.closest('.lb-vd-container') || table;
    let note = container.nextElementSibling;
    if (!note?.classList.contains('ww-tier-note')) {
      note = document.createElement('p');
      note.className = 'ww-tier-note';
      container.after(note);
    }
    if (note.textContent !== labels.tierNote) note.textContent = labels.tierNote;
  }
  function refresh(state) {
    const { form, product } = state;
    const input = form.querySelector('input[name="quantity"][data-quantity-input]');
    const variantId = form.querySelector('[name="id"]')?.value;
    const variant = product.variants?.find(v => String(v.id) === String(variantId));
    const quantity = Number(input?.value);
    const valid = input && input.value.trim() !== '' && input.validity.valid && Number.isSafeInteger(quantity) && quantity > 0;
    const tier = valid ? readTier(form, quantity, product) : { percent: null };
    refreshUnit(state, variant, tier, valid, quantity);
    refreshTierPrices(state, variant);
    const addonLines = valid ? selectedAddons(form, product, quantity) : null;
    const lines = variant && addonLines ? [{unit:variant.price, quantity, kind:'base', discounted:true, taxable:variant.taxable === true}, ...addonLines] : null;
    const calculation = valid && lines && !context.taxExempt && !form.querySelector('[name="selling_plan"]')?.value ? calculate(lines, tier.percent) : null;
    const complete = isComplete(form);
    const vatAvailable = calculation && context.country === 'DE' && context.taxesIncluded && lines.every(line => line.taxable);
    form.classList.toggle('ww-price-order--calculated', Boolean(calculation));
    for (const host of [state.bottom]) {
      setText(host, '[data-ww-price-count]', valid ? format(labels.count, { quantity }) : '—');
      setText(host, '[data-ww-price-unit]', variant && valid ? format(labels.unit, { quantity, price: money(variant.price) }) : '');
      setText(host, '[data-ww-price-base]', variant && valid ? money(variant.price * quantity) : '—');
      setText(host, '[data-ww-price-total-label]', context.taxesIncluded ? (complete ? labels.grossTotal : labels.grossSubtotal) : (complete ? labels.total : labels.subtotal));
      setText(host, '[data-ww-price-net-label]', complete ? labels.netTotal : labels.netSubtotal);
      setText(host, '[data-ww-price-net]', vatAvailable ? money(calculation.total - calculation.vat) : '—');
      host.querySelector('[data-ww-price-net-row]').hidden = !vatAvailable;
      setText(host, '[data-ww-price-total]', calculation ? money(calculation.total) : '—');
      setText(host, '[data-ww-price-note]', !valid ? labels.invalid : !calculation ? labels.unavailable : complete ? (context.taxesIncluded ? labels.complete : labels.net) : labels.incomplete);
      host.querySelector('[data-ww-price-addon-row]').hidden = !calculation?.addons;
      host.querySelector('[data-ww-price-fixed-row]').hidden = !calculation?.fixed;
      host.querySelector('[data-ww-price-discount-row]').hidden = !calculation?.discount;
      host.querySelector('[data-ww-price-vat-row]').hidden = !vatAvailable;
      if (calculation) {
        setText(host, '[data-ww-price-addons]', money(calculation.addons));
        setText(host, '[data-ww-price-addon-unit]', format(labels.unit, { quantity, price: money(calculation.addons / quantity) }));
        setText(host, '[data-ww-price-fixed]', money(calculation.fixed));
        setText(host, '[data-ww-price-discount-label]', labels.discount + ' (' + tier.percent + ' %)');
        setText(host, '[data-ww-price-discount]', '−' + money(calculation.discount));
        setText(host, '[data-ww-price-vat]', money(calculation.vat));
      }
    }
    const source = form.querySelector('.product-price');
    if (source) {
      const sourceLabel = source.previousElementSibling?.querySelector('strong');
      if (sourceLabel?.textContent.trim() === 'Stückpreis (inkl. MwSt.) vor Druck und Rabatten:') sourceLabel.textContent = labels.baseHeading;
      source.classList.toggle('ww-price-source', Boolean(calculation));
      if (source.previousElementSibling?.classList.contains('product-text-wrapper')) source.previousElementSibling.classList.toggle('ww-price-source-label', Boolean(calculation));
    }
  }
  function scan() {
    frame = 0;
    for (const [form] of states) if (!form.isConnected) states.delete(form);
    for (const form of root.querySelectorAll('form.product-form[data-template="true"]')) {
      const source = form.querySelector('.product-price');
      const bottomAnchor = form.querySelector('.product-add-to-cart');
      const json = form.querySelector('[data-js-product-json]');
      if (!source || !bottomAnchor || !json) continue;
      let state = states.get(form);
      if (!state) {
        let product;
        try { product = JSON.parse(json.textContent); } catch { continue; }
        const top = form.querySelector('[data-ww-unit-price]');
        const bottom = template.content.firstElementChild.cloneNode(true);
        bottom.classList.add('ww-price-summary--bottom');
        state = {form, product, top, bottom};
        states.set(form, state);
        form.classList.add('ww-price-order');
      }
      if (state.bottom.nextElementSibling !== bottomAnchor) bottomAnchor.before(state.bottom);
      refresh(state);
    }
  }
  const schedule = () => { if (!frame) frame = requestAnimationFrame(scan); };
  const delayed = () => {
    schedule();
    clearTimeout(trailing);
    trailing = setTimeout(schedule, 150);
  };
  for (const event of ['input', 'change', 'click']) root.addEventListener(event, e => {
    if (e.target.closest('form.product-form') && !e.target.closest('.ww-price-summary')) delayed();
  });
  new MutationObserver(records => {
    if (records.some(record => {
      const element = record.target.nodeType === 1 ? record.target : record.target.parentElement;
      if (!element || element.closest('.ww-price-summary, .ww-unit-price, .ww-tier-price-cell, .ww-tier-note')) return false;
      if (record.type === 'attributes') return element.matches('.gpo-hidden-inputs input, input[name="quantity"], [name="id"], .gpo-element');
      return Boolean(element.closest('.gpo-app, .gpo-hidden-inputs, .product-price, .shopify-app-block')) || Array.from(record.addedNodes).some(node => node.nodeType === 1 && (node.matches('form.product-form, .gpo-app, .gpo-hidden-inputs') || node.querySelector('form.product-form, .gpo-app')));
    })) schedule();
  }).observe(root, { childList:true, subtree:true, characterData:true, attributes:true, attributeFilter:['value', 'disabled', 'gpo-data-variant-id', 'gpo-data-product-handle', 'data-addon-price', 'data-quantity', 'data-advanced-addon', 'style'] });
  desktop.addEventListener('change', () => {
    schedule();
  });
  document.addEventListener('shopify:section:load', schedule);
  window.addEventListener('pageshow', schedule);
  schedule();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ww-product-sections"] && !Shopify.designMode) return;
  try {
    (() => {
  const root = document.getElementById('MainContent');
  if (!root) return;
  const products = new WeakMap();
  let frame = 0;
  function statusFor(available, text) {
    if (available === false) return 'unavailable';
    const status = text.replace(/\s+/g, ' ').trim().toLocaleLowerCase();
    if (/^(?:artikel\s+)?(?:direkt|sofort) lieferbar\b/.test(status)) return 'available';
    if (/^(?:artikel\s+)?(?:nicht lieferbar|nicht bestellbar|ausverkauft)\b/.test(status)) return 'unavailable';
    if (/^(?:artikel\s+)?(?:mit verlängerter lieferzeit|verlängerte lieferzeit|vorbestellung|nachbestellung|lieferverzögerung|verzögert lieferbar)\b/.test(status)) return 'delayed';
    return 'unknown';
  }
  function refresh() {
    frame = 0;
    for (const panel of root.querySelectorAll('.ww-delivery-panel')) {
      const form = panel.closest('form');
      if (!form) continue;
      const node = form.querySelector('[data-js-product-json]');
      let saved = products.get(form);
      if (node && (!saved || saved.node !== node)) {
        try { saved = {node, product: JSON.parse(node.textContent)}; products.set(form, saved); }
        catch { continue; }
      }
      const id = form.querySelector('[name="id"]')?.value;
      const variant = saved?.product.variants?.find(item => String(item.id) === String(id));
      // Match the explicit status at the start of the app message, regardless of b/strong/span markup.
      const message = panel.querySelector('.delivery_msg');
      const status = statusFor(variant?.available, message?.innerText || '');
      if (panel.dataset.wwStatus !== status) panel.dataset.wwStatus = status;
    }
  }
  const schedule = () => { if (!frame) frame = requestAnimationFrame(refresh); };
  root.addEventListener('change', schedule);
  new MutationObserver(records => {
    if (records.some(record => {
      const el = record.target.nodeType === 1 ? record.target : record.target.parentElement;
      return el?.closest('.ww-delivery-panel') || Array.from(record.addedNodes).some(node =>
        node.nodeType === 1 && (node.matches('.ww-delivery-panel, form.product-form') || node.querySelector('.ww-delivery-panel')));
    })) schedule();
  }).observe(root, {childList: true, subtree: true, characterData: true});
  document.addEventListener('shopify:section:load', schedule);
  window.addEventListener('pageshow', schedule);
  schedule();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ww-quote-prices"] && !Shopify.designMode) return;
  try {
    (() => {
  const data = document.getElementById('ww-quote-price-data')?.dataset;
  if (!data || data.enabled !== 'true' || new URLSearchParams(location.search).get('page') !== 'request') return;
  const items = JSON.parse(data.items);
  const money = new Intl.NumberFormat(data.locale, {style:'currency', currency:'EUR'});
  const cents = text => {
    const raw = text.replace(/\s|€|EUR/g, '');
    if (/^-?(?:\d{1,3}(?:\.\d{3})+|\d+),\d{2}$/.test(raw)) return Math.round(Number(raw.replace(/\./g, '').replace(',', '.')) * 100);
    if (/^-?(?:\d{1,3}(?:,\d{3})+|\d+)\.\d{2}$/.test(raw)) return Math.round(Number(raw.replace(/,/g, '')) * 100);
    return NaN;
  };
  const tax = (gross, taxable) => taxable ? Math.round(gross * 19 / 119) : 0;
  let frame = 0;
  const observer = new MutationObserver(schedule);
  const observe = () => observer.observe(document.getElementById('MainContent') || document.body, {childList:true, subtree:true, characterData:true});
  function schedule() {
    if (!frame) frame = requestAnimationFrame(() => { frame = 0; render(); });
  }
  function render() {
    observer.disconnect();
    try {
      const table = document.querySelector('#quick-quote-wrapper #qq-table-wrapper table');
      if (!table) return;
      table.querySelectorAll('[data-ww-quote-price]').forEach(node => node.remove());
      table.querySelectorAll('.ww-quote-price').forEach(node => node.classList.remove('ww-quote-price'));
      document.getElementById('ww-quote-tax-note')?.remove();
      if (document.getElementById('customAddressCountryField_9834')?.value !== 'DE') return;
      const rows = Array.from(table.querySelectorAll('tr.cart-item-row'));
      let matched = 0;
      let lineSum = 0;
      let taxSum = 0;
      for (const row of rows) {
        const cell = row.querySelector('td.price');
        const amount = cell?.querySelector(':scope > span');
        const gross = cents(amount?.textContent || '');
        const quantity = Number(row.querySelector('.qq-quantity-badge')?.textContent.trim());
        const candidates = items.filter(item => item.variant === row.dataset.lineId && item.quantity === quantity && (item.unit === gross || item.line === gross));
        if (!candidates.length || !Number.isFinite(gross) || candidates.some(item => item.taxable !== candidates[0].taxable || item.line !== candidates[0].line)) continue;
        const item = candidates[0];
        const grossLabel = document.createElement('small');
        grossLabel.className = 'ww-quote-gross-label';
        grossLabel.dataset.wwQuotePrice = '';
        grossLabel.textContent = data.gross;
        const net = document.createElement('span');
        net.className = 'ww-quote-net';
        net.dataset.wwQuotePrice = '';
        const netLabel = document.createElement('small');
        netLabel.textContent = data.net;
        net.append(money.format((gross - tax(gross, item.taxable)) / 100), netLabel);
        cell.classList.add('ww-quote-price');
        amount.after(grossLabel, net);
        matched++;
        lineSum += item.line;
        taxSum += tax(item.line, item.taxable);
      }
      if (!matched) return;
      const summary = table.querySelector('tr.summary');
      const subtotal = cents(summary?.querySelector('.total')?.textContent || '');
      if (matched === rows.length && matched === items.length && subtotal === Number(data.total) && subtotal === lineSum && summary) {
        for (const [label, value] of [[data.subtotal, subtotal - taxSum], [data.tax, taxSum]]) {
          const row = document.createElement('tr');
          row.className = 'ww-quote-summary';
          row.dataset.wwQuotePrice = '';
          const name = document.createElement('td');
          name.colSpan = 2;
          name.textContent = label;
          const price = document.createElement('td');
          price.textContent = money.format(value / 100);
          row.append(name, price);
          summary.before(row);
        }
      }
      const note = document.createElement('p');
      note.id = 'ww-quote-tax-note';
      note.className = 'ww-quote-tax-note';
      note.textContent = data.note;
      table.after(note);
    } finally { observe(); }
  }
  document.addEventListener('change', event => {
    if (event.target.id === 'customAddressCountryField_9834') schedule();
  });
  render();
  window.addEventListener('pagehide', () => { observer.disconnect(); cancelAnimationFrame(frame); }, {once:true});
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ww-volume-selection"] && !Shopify.designMode) return;
  try {
    (() => {
  const template = document.getElementById('ww-volume-template');
  const labelNode = document.getElementById('ww-volume-labels');
  const root = document.getElementById('MainContent');
  if (!template || !labelNode || !root) return;
  const labels = JSON.parse(labelNode.textContent);
  const states = new Map();
  const desktop = window.matchMedia('(min-width: 992px)');
  let serial = 0;
  let frame = 0;
  let forwarding = false;
  const format = (text, values) => text.replace(/\[\[(\w+)\]\]/g, (_, key) => values[key] ?? '');
  const integer = value => /^\d+$/.test(value) && Number.isSafeInteger(Number(value)) ? Number(value) : NaN;
  const range = value => {
    const normalized = value.replace(/(\d)[.,\s\u00a0\u202f](?=\d{3}(?:\D|$))/g, '$1').trim();
    const match = normalized.match(/^(\d+)\s*[-–—]\s*(\d+)(?:\D.*)?$/);
    if (match) return [Number(match[1]), Number(match[2])];
    const open = normalized.match(/^(?:ab|from|at least)\s+(\d+)(?:\D.*)?$/i) || normalized.match(/^(\d+)\s*\+(?:\D.*)?$/);
    return open ? [Number(open[1]), Infinity] : null;
  };
  const tiers = table => Array.from(table.querySelectorAll('tbody tr')).map(row => {
    const cells = row.querySelectorAll('td');
    const bounds = cells[0] && range(cells[0].textContent.trim());
    const percent = cells[1] && cells[1].textContent.match(/(\d+(?:[.,]\d+)?)\s*%/);
    if (!bounds || !percent || bounds[0] > bounds[1]) return null;
    return { row, min: bounds[0], max: bounds[1], percent: percent[1] };
  }).filter(Boolean);
  function refresh(state) {
    const original = state.form.querySelector('input[name="quantity"][data-quantity-input]');
    const table = state.form.querySelector('.lb-vd-table');
    state.original = original;
    const entries = table ? tiers(table) : [];
    state.host.hidden = !original || !entries.length || original.dataset.limitToOne === 'true';
    if (state.host.hidden) return;
    for (const attr of ['min', 'max', 'step']) {
      const value = original.getAttribute(attr);
      if (value !== null && value !== '') {
        if (state.input.getAttribute(attr) !== value) state.input.setAttribute(attr, value);
      } else if (state.input.hasAttribute(attr)) state.input.removeAttribute(attr);
    }
    state.input.disabled = original.disabled;
    state.input.readOnly = original.readOnly;
    if (document.activeElement !== state.input && state.input.value !== original.value) state.input.value = original.value;
    const quantity = integer(document.activeElement === state.input ? state.input.value : original.value);
    const min = Number(original.min) || 1;
    const max = original.max && Number(original.max) > 0 ? Number(original.max) : Infinity;
    const step = Number(original.step) || 1;
    const valid = Number.isFinite(quantity) && quantity >= min && quantity <= max && (quantity - min) % step === 0;
    const active = valid ? entries.find(t => quantity >= t.min && quantity <= t.max) : null;
    for (const entry of entries) {
      entry.row.classList.toggle('ww-volume-active', entry === active);
      if (entry === active) {
        if (entry.row.getAttribute('aria-current') !== 'true') entry.row.setAttribute('aria-current', 'true');
      } else entry.row.removeAttribute('aria-current');
    }
    const message = !valid ? labels.invalid : active
      ? format(labels.discount, { percent: active.percent, quantity })
      : quantity < Math.min(...entries.map(t => t.min))
        ? format(labels.from, { quantity: Math.min(...entries.map(t => t.min)) }) : labels.none;
    if (state.result.textContent !== message) state.result.textContent = message;
    state.result.dataset.active = active ? 'true' : 'false';
    state.minus.disabled = original.disabled || original.readOnly || quantity <= min;
    state.plus.disabled = original.disabled || original.readOnly || quantity >= max;
  }
  function write(state, commit) {
    const original = state.original;
    if (!desktop.matches || !original || original.disabled || original.readOnly) return;
    if (!state.input.validity.valid || !Number.isFinite(integer(state.input.value))) {
      if (commit) state.input.value = original.value;
      refresh(state);
      return;
    }
    if (original.value !== state.input.value) {
      original.value = state.input.value;
      forwarding = true;
      original.dispatchEvent(new Event('input', { bubbles: true }));
      forwarding = false;
      original.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (commit) state.input.value = original.value;
    refresh(state);
  }
  function scan() {
    frame = 0;
    if (!desktop.matches) return;
    for (const [form, state] of states) {
      if (!form.isConnected) states.delete(form);
      else refresh(state);
    }
    for (const table of root.querySelectorAll('.lb-vd-table')) {
      const form = table.closest('form');
      const original = form && form.querySelector('input[name="quantity"][data-quantity-input]');
      if (!original || original.dataset.limitToOne === 'true' || !tiers(table).length) continue;
      const anchor = table.closest('.shopify-app-block') || table.parentElement;
      anchor.classList.add('ww-volume-table-block');
      let state = states.get(form);
      if (!state) {
        const host = template.content.firstElementChild.cloneNode(true);
        const input = host.querySelector('[data-ww-volume-input]');
        const result = host.querySelector('.ww-volume-selection__result');
        input.id = 'ww-volume-quantity-' + (++serial);
        result.id = input.id + '-result';
        input.setAttribute('aria-describedby', result.id);
        host.querySelector('label').htmlFor = input.id;
        input.value = original.value;
        state = { form, host, input, result, original, minus: host.querySelector('[data-ww-volume-minus]'), plus: host.querySelector('[data-ww-volume-plus]') };
        states.set(form, state);
        input.addEventListener('input', () => write(state, false));
        input.addEventListener('change', () => write(state, true));
        input.addEventListener('blur', () => write(state, true));
        input.addEventListener('keydown', event => {
          if (event.key === 'Enter') { event.preventDefault(); write(state, true); }
        });
        for (const [button, direction] of [[state.minus, -1], [state.plus, 1]]) {
          button.addEventListener('click', () => {
            input.value = state.original.value;
            if (direction < 0) input.stepDown(); else input.stepUp();
            write(state, true);
          });
        }
      }
      if (state.host.parentElement !== anchor || anchor.firstElementChild !== state.host) anchor.prepend(state.host);
      refresh(state);
    }
  }
  const schedule = () => { if (desktop.matches && !frame) frame = requestAnimationFrame(scan); };
  for (const name of ['input', 'change', 'click']) root.addEventListener(name, event => {
    if (!desktop.matches) return;
    if (name === 'input' && !forwarding && states.has(event.target.closest('form')) && event.target.matches('input[name="quantity"][data-quantity-input]') && event.target.validity.valid && Number.isFinite(integer(event.target.value))) {
      event.target.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (event.target.closest('form') && !event.target.closest('[data-ww-volume-selection]')) schedule();
  });
  const observer = new MutationObserver(records => {
    if (records.some(record => {
      if (record.target.nodeType === 1 && record.target.closest('[data-ww-volume-selection]')) return false;
      if (record.type === 'attributes') return record.target.matches('input[name="quantity"][data-quantity-input]');
      return record.target.nodeType === 1 && (record.target.closest('.shopify-app-block') || record.target.closest('form')) || Array.from(record.addedNodes).some(node => node.nodeType === 1 && (node.matches('form,.shopify-section') || node.querySelector('.lb-vd-table')));
    })) schedule();
  });
  function updateViewport() {
    observer.disconnect();
    if (desktop.matches) {
      observer.observe(root, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['min', 'max', 'step', 'disabled', 'readonly', 'value'] });
      schedule();
    } else {
      if (frame) cancelAnimationFrame(frame);
      frame = 0;
      for (const state of states.values()) state.host.remove();
      states.clear();
      for (const row of root.querySelectorAll('.ww-volume-active')) {
        row.classList.remove('ww-volume-active');
        row.removeAttribute('aria-current');
      }
      for (const block of root.querySelectorAll('.ww-volume-table-block')) block.classList.remove('ww-volume-table-block');
    }
  }
  desktop.addEventListener('change', updateViewport);
  document.addEventListener('shopify:section:load', schedule);
  window.addEventListener('pageshow', updateViewport);
  updateViewport();
})();
  } catch(e) { console.error(e); }
})();

})();
